import { Button, Select } from "antd";
import React, { useState } from "react";
import useGroupBranchesByType from "../useGroupBranchesByType";
import useGroupBranchSwitch from "../useGroupBranchSwitch";

/**
 * Not a cross-branch screen of its own — picking a branch here switches the
 * acting branch (the exact goToBranch every other branch-name link in the
 * Group Console already uses) and lands on that branch's real, completely
 * unmodified admin Course Board: same class dropdown, same subject list,
 * same "Click to view," same tabs, same create/edit capability a branch
 * admin already has. One branch per visit, not "All Branches."
 */
const GroupSeniorCourseBoard = () => {
  const { options, isLoading } = useGroupBranchesByType(false);
  const { goToBranch, switching } = useGroupBranchSwitch();
  const [school, setSchool] = useState(undefined);

  return (
    <div className="p-8">
      <div
        style={{ borderRadius: "10px", color: "#616161" }}
        className="bg-white drop-shadow-md p-8 w-full"
      >
        <div className="text-2xl text-orange-500 font-semibold pb-1">
          Senior Course Board
        </div>
        <div className="text-sm text-gray-500 pb-6">
          Choose a branch to open its Course Board — the same screen that
          branch's own admin uses, with full create and edit access.
        </div>

        <div className="flex items-center gap-3">
          <Select
            style={{ width: 320 }}
            placeholder="Choose a branch"
            options={options}
            loading={isLoading}
            value={school}
            onChange={setSchool}
          />
          <Button
            type="primary"
            disabled={!school}
            loading={switching}
            onClick={() => goToBranch(school, "/dashboard/admin/menu/course-board")}
          >
            View Course Board
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GroupSeniorCourseBoard;
